export enum TransitionTypeEnum {
  slideUp = 'transition-slide-up',
}
